<template>
  <ToastAlert v-if="show" :message="message" :type="type" :duration="duration" @close="closeToast" />
</template>

<script setup>
import { useToast } from "~/composables/useToast";
const { show, message, type, duration, closeToast } = useToast();
</script>
